import { ApiError, downloadFile } from "../../api/client.ts"
import type { Case } from "../../api/types.ts"
import { useAsyncAction } from "../../hooks/index.ts"
import { useT } from "../../i18n/index.tsx"
import { canPrintInvoice } from "../../lib/case-invoice.ts"
import { Button, useToast } from "../../ui/index.ts"

/**
 * 반품 건별 COMMERCIAL INVOICE 내려받기.
 *
 * 뽑을 수 있는지는 `lib/case-invoice.ts` 하나가 정하고 서버가 같은 판정을 다시 한다.
 * 아직 안 되는 동안에도 버튼은 두되 잠그고 이유를 붙인다 — 사라지면 왜 없는지 알 수 없다.
 *
 * 실패는 카드 머리에 경고를 끼워 넣는 대신 토스트로 알린다(자리가 좁고 표가 밀린다).
 */
export function InvoiceDownload({ item, itemCount }: { item: Case; itemCount: number }) {
  const t = useT()
  const toast = useToast()
  const download = useAsyncAction()
  const check = canPrintInvoice({ status: item.status, itemCount })
  const reason = check.ok ? undefined : t(`blocker.${check.code}`)

  function run() {
    void download.run(async () => {
      try {
        // 파일 이름은 서버가 content-disposition 으로 준다. 못 받았을 때만 이 이름을 쓴다.
        await downloadFile(`/api/cases/${item.id}/invoice.xlsx`, `invoice_${item.seq}.xlsx`)
      } catch (err) {
        toast(t(`error.${err instanceof ApiError ? err.code : "INTERNAL"}`), "danger")
      }
    })
  }

  return (
    <Button
      size="sm"
      icon="download"
      loading={download.busy}
      disabled={!check.ok}
      title={reason}
      onClick={run}
    >
      {t("caseDetail.invoice")}
    </Button>
  )
}
